import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";
import {
  BASE_URL,
  CHECKID_VARIFICATION_REPORT_LIST,
} from "../../../../Constants/Config";

const initialState = {
  loading: false,
  CheckIDVerifyData: [],
  successMessage: "",
  error: "",
  currentPage: 1,
};
let cancelTokenSource;
let activeRequests = 0;
// Generate pening , fulfilled and rejected action type
export const fetchCheckIDVerifyData = createAsyncThunk(
  "CheckIDVerifySlice/fetchCheckIDVerifyData.",
  async (data, { rejectWithValue }) => {
    // Cancel the previous request if it exists
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Previous request canceled");
    }
    // Create a new cancel token
    cancelTokenSource = axios.CancelToken.source();
    try {
      const { token, ...newData } = data;
      const response = await axios.post(
        BASE_URL + CHECKID_VARIFICATION_REPORT_LIST,
        newData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          cancelToken: cancelTokenSource.token,
        }
      );
      if (response.data.status === true) {
        // console.log(response);
        return response.data.order_data;
      }
    } catch (error) {
      // throw new Error(error.response.data.message);
      if (axios.isCancel(error)) {
        console.log("Request canceled:", error.message);
      } else {
        const customError = {
          message: toThunkRejectValue(error).message,
          status: toThunkRejectValue(error).status,
          data: error.response ? error.response.data : null,
        };
        return rejectWithValue(customError);
      }
    }
  }
);

const CheckIDVerifySlice = createSlice({
  name: "StoreSettingAlertsList",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchCheckIDVerifyData.pending, (state, action) => {
      // Only set loading for page 1 to avoid hiding data during pagination
      const page = action.meta?.arg?.page || 1;
      if (page === 1) {
        state.loading = true;
      }
    });
    builder.addCase(fetchCheckIDVerifyData.fulfilled, (state, action) => {
      state.loading = false;
      // Append data for pagination (page > 1), replace for page 1
      const page = action.meta?.arg?.page || 1;
      if (page === 1) {
        state.CheckIDVerifyData = action.payload || [];
      } else {
        state.CheckIDVerifyData = [...state.CheckIDVerifyData, ...(action.payload || [])];
      }
      state.currentPage = page;
      state.error = "";
    });
    builder.addCase(fetchCheckIDVerifyData.rejected, (state, action) => {
      state.loading = false;
      state.CheckIDVerifyData = {};
      state.error = action.error.message;
    });
  },
});

export default CheckIDVerifySlice.reducer;
